import React from 'react';
// import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="text-center py-3 border-top">
      <div className="container">
        <p className="mb-0 text-muted" style={{ fontSize: '0.875rem' }}>
          © {new Date().getFullYear()} VoteWave. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
